<template>
  <div class="DoubleCodePop" v-if="boxClose">
    <div class="mask-container"></div>
    <div class="box-cent animated zoomIn">
      <img class="cent-bg" :src="top" alt="" />
      <div class="cent-title">提示</div>
      <div class="cent-sub-title">亲爱的健萌er，</div>
      <div class="cent-text">
        为保证您的上课安全，健萌所有教练<span>均通过了抗原或核酸检测阴性后再上岗，</span>并提供了阴性证明以供您查看。2023年，快和健萌一起开启新的训练旅程，增强您的免疫力吧！
      </div>

      <div class="cent-coach-imgs">
        <div class="img-title"
          >{{ doubleCodePopInfo.cname }}教练的健康证明：</div
        >
        <img
          class="i-img"
          :src="doubleCodePopInfo.antigen_negative_proof"
          alt
        />
      </div>
      <div
        class="cent-btn user-btn u-text-center"
        @click.stop="boxClose = false"
        >确定</div
      >
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      boxClose: false
    }
  },
  props: {
    doubleCodePopInfo: {
      required: true,
      type: Object,
      default: () => {
        return {}
      }
    },
    visible: {
      required: true,
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  watch: {
    visible(val, oldVal) {
      if (val === oldVal) return
      this.boxClose = val
    },
    boxClose(val, oldVal) {
      if (val === oldVal) return
      this.$emit('update:visible', val)
    }
  },
  computed: {
    ...mapState('coachProve', [
      'start',
      'end',
      'popTime',
      'banner',
      'pop',
      'bg',
      'top'
    ])
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.DoubleCodePop {
  width: 100%;
  height: 100%;
  .mask-container {
    background-color: #000;
    position: fixed;
    top: 0;
    left: 0;
    opacity: 0.6;
    width: 100%;
    height: 100%;
    z-index: 99;
  }
  .box-cent {
    width: vw(295);
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -55%);
    box-sizing: border-box;
    padding: vw(20);
    background-color: #fff;
    border-radius: vw(8);
    color: #000;
    text-align: left;
    z-index: 100;
    .cent-bg {
      position: absolute;
      z-index: -1;
      top: 0;
      left: 0;
      width: 100%;
      box-sizing: border-box;
    }
    .cent-title {
      font-size: vw(20);
      font-weight: 600;
      color: #000000;
      margin-bottom: vw(10);
      text-align: center;
    }
    .cent-sub-title {
      text-align: left;
      font-size: vw(14);
      font-weight: 600;
      line-height: vw(20);
    }
    .cent-text {
      font-size: vw(13);
      color: #000000;
      text-align: left;
      line-height: vw(20);
      span {
        color: #dc0050;
        font-weight: 600;
      }
    }
    .cent-coach-imgs {
      width: 100%;
      box-sizing: border-box;
      padding: vw(15) vw(20);
      margin-top: vw(16);
      background-color: #f7f7f7;
      border-radius: vw(6);
      text-align: left;
      margin-top: vw(16);
      .img-title {
        font-size: vw(13);
        font-weight: 500;
        color: #333233;
      }
      .i-img {
        width: auto;
        height: vw(121);
        object-fit: cover;
        margin: 0 auto;
        margin-top: vw(12);
        display: block;
      }
    }
    .cent-btn {
      width: vw(255);
      height: vw(44);
      background: #dc0050;
      border-radius: vw(22);
      color: #fff;
      font-size: vw(18);
      font-weight: 600;
      margin: 0 auto;
      margin-top: vw(16);
    }
  }
}
</style>
<style lang="scss">
.GymMessageBox {
  .animated {
    animation-duration: 0.5s;
  }
}
</style>
